module.exports = __webpack_public_path__ + "img/f_5.f2ffad3.png";